import { useMemo, useState } from "react"
import { File } from "../../../../gql/graphql"
import useImage from "../../../../hooks/useImage"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import { Carousel } from "react-responsive-carousel"
import ImageDownloadModal from "../../../Common/ImageDownloadModal/ImageDownloadModal"
import useLang from "../../../../hooks/useLang"

interface Props {
  images: File[] | undefined
}

const OrderImages = ({ images }: Props) => {
  const [open, setOpen] = useState(false)
  const { getUri } = useImage()
  const { getText } = useLang()

  const handleClose = () => {
    setOpen(false)
  }

  const imageUrls = useMemo(
    () => images?.map((el) => ({ id: el.id, src: getUri(el.url) })) || [],
    [getUri, images],
  )

  if (!images?.length) return <span>{getText("Pas definie")}</span>

  return (
    <div style={{ width: "150px", margin: "0 auto" }}>
      <Carousel
        infiniteLoop
        showThumbs={false}
        showIndicators={true}
        showStatus={false}
        onClickItem={() => setOpen(true)}
        dynamicHeight={false}
      >
        {images?.map((image) => (
          <div key={image.id} style={{ padding: "10px" }}>
            <img
              style={{
                width: "100%",
                height: "150px",
                objectFit: "cover",
                cursor: "pointer",
                borderRadius: "10px",
              }}
              alt={image.name}
              src={getUri(image.url)}
            />
          </div>
        ))}
      </Carousel>

      <ImageDownloadModal
        imageUrls={imageUrls}
        onClose={handleClose}
        open={open}
      />
    </div>
  )
}

export default OrderImages
